import React from "react";
import '../styles/components/Courses.css'

const Courses = () => {

    return (
        <>
            <div className='courses'>
                <h1>الدورات</h1>
                <h2>التـي  أقدمهــا</h2>
                <div className='figures'>
                    <div className='figure'>
                        <h1>تدريب الشركات</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود</p>
                        <a className="button">انقـر للمزيـد</a>
                    </div>
                    <div className='figure'>
                        <h1>استشارات الأعمال</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود</p>
                        <a className="button">انقـر للمزيـد</a>
                    </div>
                    <div className='figure'>
                        <h1>كوتشينج الأعمال</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود</p>
                        <a className="button">انقـر للمزيـد</a>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Courses